var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.46,
    height: 36.911,
    viewBox: "0 0 20.46 36.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21630",
    "data-name": "\\uADF8\\uB8F9 21630",
    transform: "translate(1.063 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28089",
    "data-name": "\\uC0AC\\uAC01\\uD615 28089",
    width: 17.59,
    height: 22.544,
    rx: 1,
    transform: "translate(0 12.367)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1215",
    "data-name": "\\uD0C0\\uC6D0 1215",
    cx: 4.188,
    cy: 4.188,
    r: 4.188,
    transform: "matrix(0.189, -0.982, 0.982, 0.189, 3.892, 26.63)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10236",
    "data-name": "\\uD328\\uC2A4 10236",
    d: "M87.021,152.079a10.37,10.37,0,0,1,17.714.223",
    transform: "translate(-86.707 -147.212)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10237",
    "data-name": "\\uD328\\uC2A4 10237",
    d: "M93.189,154.152a5.158,5.158,0,0,1,8.81.111",
    transform: "translate(-88.423 -146.401)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartKey);
export default __webpack_public_path__ + "static/media/SmartKey.eb68dfa6499ce9bcf89a5a88ad6e2d2c.svg";
export { ForwardRef as ReactComponent };